exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".readonly-field[data-v-2f9bb3dc]{background-color:#e9ecef!important;cursor:not-allowed}.table-sm td[data-v-2f9bb3dc],.table-sm th[data-v-2f9bb3dc]{padding:.35rem;vertical-align:middle}.scvd-flat-grid[data-v-2f9bb3dc]{min-width:1200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-2f9bb3dc","scoped":true,"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/StockCoverDays/StockCoverDaysCreate.vue
// module id = 1074
// module chunks = 0